export const GET_CHART_COUNTER = 'GET_CHART_COUNTER';
export const GET_CHART_COUNTER_SUCCESS = 'GET_CHART_COUNTER_SUCCESS';
export const GET_CHART_COUNTER_FAILURE = 'GET_CHART_COUNTER_FAILURE';
export const SET_CHART_COUNTER = 'SET_CHART_COUNTER';
